import { closeModal } from "./modal";

const asideMenu = document.querySelector('[data-modal="aside"]');

if (asideMenu) {
  asideMenu.addEventListener("click", (e) => {
    const close = e.target.closest('[data-modal="close"]');

    if (close) {
      closeModal(asideMenu);
    }
  });
}
